import React from 'react';
import InfoChip from "../../InfoChip";
import Amount from "../../Amount";
import {useTranslation} from "react-i18next";

const DataOverview = ({totalCardholders, totalAmountLoaded, uploadedData}) => {
    const { t } = useTranslation();
    return (
        <div className="step">
            <h4>{t("Create")}</h4>
            <div className="mb-4 mt-4">
                <InfoChip class="mr-3" value={totalCardholders} description={t("Total Cardholders")}/>
                <InfoChip value={<Amount amount={totalAmountLoaded} currency="USD"/>}
                          description={t("Total Amount Loaded")}/>
            </div>
            <h4>{t("CSV Field Details")}</h4>
            {uploadedData.data && uploadedData.headers && (
                <>
                    <div className="overflow-x-auto data-table small-data-table mb-4">
                        <table>
                            <thead>
                            <tr>
                                {uploadedData.headers.map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {uploadedData.data.map((item, index) => (
                                <tr key={index}>
                                    {uploadedData.headers.map((header, headerIndex) => (
                                        <td key={headerIndex}>{item[header]}</td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};

export default DataOverview;
